var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"请选择","loading":_vm.loading},on:{"change":_vm.handleChange},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.dictValue,attrs:{"label":item.dictLabel,"value":item.dictValue}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }